import ProfessionalCategory from './ProfessionalCategory'

class FranceProfessionalCategory extends ProfessionalCategory {
  static urlRoot() {
    return '/contracts/france/professional_categories'
  }
}

export default FranceProfessionalCategory
